import { render, staticRenderFns } from "./buyVip.vue?vue&type=template&id=f673fedc&"
import script from "./buyVip.vue?vue&type=script&lang=js&"
export * from "./buyVip.vue?vue&type=script&lang=js&"
import style0 from "./buyVip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports